import axios from 'axios'

const itemRepoApiClient = axios.create({
  baseURL: window.app.rewardcampaign.api_itemrepo_base,
  headers: {
    'Content-Type': 'application/json',
  }
})

itemRepoApiClient.interceptors.request.use(config => {
  if (config.url === '/v2/item/find-by-itemno/' + window.app.rewardcampaign.siteLanguageTwoLetterIsoCode + '/') {
    config.url = `${config.baseURL}/v2/item/find-by-itemno/` + window.app.rewardcampaign.siteLanguageTwoLetterIsoCode + '/'
  }
  return config
})

export default itemRepoApiClient
